module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "overlay"
    }
  }, [_c('div', {
    staticClass: "spinner"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box box-info"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "p-toolbar p-component mb-4"
  }, [_c('Button', {
    staticClass: "p-button p-component p-button-success addNewBtn btn-btm-0",
    attrs: {
      "label": "NEW",
      "icon": "pi pi-plus"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openBasic.apply(null, arguments)
      }
    }
  })], 1)]), _vm._v(" "), _c('Dialog', {
    style: ({
      width: '50vw'
    }),
    attrs: {
      "header": "Role",
      "visible": _vm.displayModal,
      "modal": true,
      "closable": false
    },
    on: {
      "update:visible": function($event) {
        _vm.displayModal = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('Button', {
          staticClass: "p-button-raised",
          attrs: {
            "label": !_vm.editing ? 'Add' : 'Update'
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.addRole.apply(null, arguments)
            }
          }
        }), _vm._v(" "), (!_vm.editing) ? _c('Button', {
          staticClass: "p-button-raised p-button-info",
          attrs: {
            "label": "Add & New"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.addAndNewRole.apply(null, arguments)
            }
          }
        }) : _vm._e(), _vm._v(" "), _c('Button', {
          staticClass: "p-button-raised p-button-danger",
          attrs: {
            "label": "Cancel"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.cancel.apply(null, arguments)
            }
          }
        })]
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "name"
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, _vm._l((_vm.moduleList), function(module, ind) {
    return _c('Accordion', {
      key: ind
    }, [_c('AccordionTab', {
      attrs: {
        "header": module.moduleName
      }
    }, [_c('Checkbox', {
      attrs: {
        "binary": true
      },
      on: {
        "change": function($event) {
          return _vm.onChange(module.moduleList, _vm.selectValue)
        }
      },
      model: {
        value: (_vm.selectValue),
        callback: function($$v) {
          _vm.selectValue = $$v
        },
        expression: "selectValue"
      }
    }), _vm._v(" "), _c('label', {
      staticStyle: {
        "margin-left": "10px"
      },
      attrs: {
        "for": "role"
      }
    }, [_vm._v("All")]), _vm._v(" "), _vm._l((module.moduleList), function(role, inx) {
      return _c('div', {
        key: inx
      }, [_c('Checkbox', {
        attrs: {
          "id": "role",
          "value": role.roleId
        },
        model: {
          value: (_vm.moduleChecked),
          callback: function($$v) {
            _vm.moduleChecked = $$v
          },
          expression: "moduleChecked"
        }
      }), _vm._v(" "), _c('label', {
        staticStyle: {
          "margin-left": "10px"
        },
        attrs: {
          "for": "role"
        }
      }, [_vm._v(_vm._s(role.roleName))])], 1)
    })], 2)], 1)
  }), 1)])])], 1), _vm._v(" "), _c('roleList', {
    on: {
      "delete-message": _vm.deleteMessage,
      "edit-role": _vm.editRole
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-711e2422"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/settings/role.vue
// module id = 2306
// module chunks = 0